import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {CoreTranslationService} from '../../../../@core/services/translation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from "../../../core/service";
import {PricingPlan} from "../../../core/helpers/constants";

@Component({
  selector: 'available-budget',
  templateUrl: './available-budget.component.html',
  styleUrls: ['./available-budget.component.scss'],
  providers: [TranslatePipe]
})
export class AvailableBudgetComponent implements OnInit, OnChanges {

  public smallText?: string;
  @Input() bigText?: string;
  @Input() expander: boolean;
  @Input() hasTransportBudget?: boolean;
  @Input() hasProfessionalDevelopmentBudget?: boolean;
  @Input() hasCashbackBudget?: boolean;
  @Input() standardBudget?: number;
  @Input() transportBudget?: number;
  @Input() professionalDevelopmentBudget?: number;
  @Input() cashbackBudget?: number;
  @Input() cashbackPendingAmount?: number;
  public showLinkInsteadFlag = false;
  public subdomain = 'default';
  isCompact = false;
  private resizeObserver: ResizeObserver;
  isCollapsed1 = true;
  private companyPrincingPlan : PricingPlan;

  constructor(private _coreTranslationService: CoreTranslationService,
    private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
              private authService: AuthenticationService) {
    this.subdomain = this.route.snapshot.params['subdomain'];
    this.companyPrincingPlan = this.authService.currentUserCompanyInfoValue?.pricingPlan || PricingPlan.FLEX;
  }

  ngOnInit(): void {
    this.smallText = this.companyPrincingPlan === PricingPlan.LITE && this.hasCashbackBudget === true ? 'BUDGET.AVAILABLE_CASHBACK_TITLE' : 'BUDGET.AVAILABLE_BUDGET_TITLE'
    if (this.bigText && this.bigText.startsWith('-')) {
      this.showLinkInsteadFlag = true;
      this.bigText = this.bigText.substring(1);
    }
    if (!this.transportBudget) {
      this.transportBudget = 0;
    }

    if (!this.professionalDevelopmentBudget) {
      this.professionalDevelopmentBudget = 0;
    }

    if (!this.cashbackBudget) {
      this.cashbackBudget = 0;
    }

    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.isCompact = width < 200;
      }
    });

    this.resizeObserver.observe(this.el.nativeElement.parentElement);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  public goToHistory() {
    this.router.navigate(['/' + this.subdomain + '/benefits-history']);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bigText &&
            changes.bigText?.previousValue?.startsWith('-') &&
            !changes.bigText?.currentValue?.startsWith('-')) {
      this.showLinkInsteadFlag = false;
    }
    if(changes.standardBudget || changes.transportBudget || changes.professionalDevelopmentBudget) {
      const totalAmount = Number(this.bigText?.substring(0));
      let realTotalAmount = this.standardBudget;
      if(this.hasTransportBudget) {
        realTotalAmount += this.transportBudget;
      }
      if(this.hasProfessionalDevelopmentBudget) {
        realTotalAmount += this.professionalDevelopmentBudget;
      }
      if (this.cashbackBudget) {
        realTotalAmount += this.cashbackBudget;
      }
      if(totalAmount !== realTotalAmount) {
        this.bigText = realTotalAmount.toFixed(2) + ' RON';
      }
    }
  }
}
